import moment from "moment";

export const formatUTCtoLocalDate = (date: string, format: string) =>
  moment
    .utc(date)
    .local()
    .format(format);
